import React, { createContext, useEffect, useState } from 'react'
import {
  createUserWithEmailAndPassword,
  getAuth,
  GoogleAuthProvider,
  onAuthStateChanged,
  sendEmailVerification,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
  updateProfile,
} from 'firebase/auth'
import app from '../firebase/firebase.init'

export const AuthContext = createContext()

const auth = getAuth(app)

const UserContext = ({ children }) => {
  const [user, setUser] = useState({})
  const [loading, setLoading] = useState(true)

  const googleProvider = new GoogleAuthProvider()

  const createUser = (email, password) => {
    return createUserWithEmailAndPassword(auth, email, password)
  }
  const updateName = name => {
    return updateProfile(auth.currentUser, {
      displayName: name,
    })
  }

  const resetPassword = email => {
    return sendPasswordResetEmail(auth, email)
  }
  const verifyEmail = () => {
    return sendEmailVerification(auth.currentUser)
  }

  const signIn = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password)
  }

  const signInWithGoogle = () => {
    return signInWithPopup(auth, googleProvider)
  }

  const logOut = () => {
    return signOut(auth)
  }

  // why are we doing this?
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, currentUser => {
      setUser(currentUser)
      setLoading(false)
      console.log('auth state changed', currentUser)
    })

    return () => {
      unsubscribe()
    }
  }, [])

  const authInfo = {
    user,
    loading,
    createUser,
    signIn,
    logOut,
    signInWithGoogle,
    updateName,
    resetPassword,
    verifyEmail,
  }

  return (
    <AuthContext.Provider value={authInfo}>{children}</AuthContext.Provider>
  )
}

export default UserContext
